/* eslint-disable no-unused-vars */
import { update } from "lodash";
import axios from "../../axios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async index({ commit }, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`feedbacks?${new URLSearchParams(query)}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async store({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("feedbacks", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async update({ commit }, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`feedbacks/${id}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {},
};
